import React from 'react';
import { Typography, Box } from '@mui/material';
import './PageHeader.scss';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  className = '',
}) => {
  return (
    <Box data-testid="page-header" className={`pageHeader ${className}`}>
      <Typography
        data-testid="page-header-title"
        variant="h4"
        className="pageHeaderTitle"
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          data-testid="page-header-subtitle"
          variant="body1"
          className="pageHeaderSubtitle"
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeader;
